import { Link, TableCell, TableRow } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { SwissGermanLocale, SwissTimeZone } from "../../../data/constants";
import { ExamTypeTranslationKey } from "../../../model/Exam";
import { ExamSessionCandidateExamStateTranslationKey } from "../../../model/examSessionCandidate/ExamSessionCandidateExamViewModel";
import { CandidateMyExamViewModel } from "../../../model/me/CandidateMyExamViewModel";
import { GetTranslatedValueIntl } from "../../../model/Shared/TranslatedValue";
import TranslatedMessage from "../../translations/TranslatedMessage";
import { TranslationKey } from "../../../translations/TranslationKey";

type MyExamsTableExamRowProps = {
  exam: CandidateMyExamViewModel;
};

const MyExamsTableExamRow = ({ exam }: MyExamsTableExamRowProps) => {
  const intl = useIntl();
  return (
    <TableRow>
      <TableCell />
      <TableCell>{GetTranslatedValueIntl(intl, exam.name)}</TableCell>
      <TableCell>
        <TranslatedMessage id={ExamTypeTranslationKey[exam.type]} />
      </TableCell>
      <TableCell>
        {exam.location ? (
          <Link href={exam.location.linkToMap} target="_blank" rel="noopener noreferrer" color="initial">
            <div>
              <div>{exam.location.name}</div>
              <div>{exam.location.street}</div>
              <div>{exam.location.zipCode + " " + exam.location.city}</div>
              {exam.language ? (
                <div>
                  (<TranslatedMessage id={`common.language.${exam.language.toLowerCase()}` as TranslationKey} />)
                </div>
              ) : null}
            </div>
          </Link>
        ) : null}
      </TableCell>
      <TableCell>
        {exam.date ? new Date(exam.date).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone }) : ""}
      </TableCell>
      <TableCell>{exam.timeSlot?.arrivalTime}</TableCell>
      <TableCell>{exam.room}</TableCell>
      <TableCell>{<TranslatedMessage id={ExamSessionCandidateExamStateTranslationKey[exam.status]} />}</TableCell>
      <TableCell>{exam.grade}</TableCell>
      <TableCell align="center"></TableCell>
    </TableRow>
  );
};

export default MyExamsTableExamRow;
